import React from 'react';

import { PageItemRemote } from './page-item-remote';

import './style.scss';

const HomeShortPagesRemote = ({ slidesData }) => {
  const list = ['UpperLeft', 'UpperCenter', 'UpperRight']
    .map(key => [key, slidesData?.[key]])
    .filter(([, value]) => Boolean(value));

  return (
    <div className="home-short-pages home-short-pages-remote">
      {list.map(([key, comp]) => (
        <PageItemRemote key={key} slides={comp} />
      ))}
    </div>
  );
};

export default HomeShortPagesRemote;
